import { ReactWidget } from '@theia/core/lib/browser';
import { injectable, postConstruct } from '@theia/core/shared/inversify';

type UiModule = {
    Tooltip: () => JSX.Element;
};

/**
 * Hosts portaled @lved/ui surfaces that must sit on document.body.
 * Notifications use Theia's @theia/messages toasts; this widget only mounts Tooltip.
 */
@injectable()
export class TooltipHostWidget extends ReactWidget {
    static readonly ID: string = 'widget:lved-tooltip-host';

    protected module: UiModule | undefined;

    @postConstruct()
    protected init(): void {
        this.doInit();
    }

    protected async doInit(): Promise<void> {
        this.id = TooltipHostWidget.ID;
        this.title.closable = false;
        this.node.id = 'lved-tooltip-host';
        await this.loadModule();
        this.update();
    }

    protected async loadModule(): Promise<void> {
        try {
            this.module = (await import('@lved/ui')) as unknown as UiModule;
        } catch {
            this.module = undefined;
        }
    }

    protected override render(): JSX.Element {
        if (!this.module) return <></>;
        const Tooltip = this.module.Tooltip;
        return <Tooltip />;
    }
}
